import {
  SessionsData,
  SourceType,
  SessionsAction,
  SessionDataType,
  SessionState,
} from "./types";

export const initialState: SessionsData = {
  list: [],
  currentAccounts: {
    primaryEmail: "",
    profilePk: -1,
    firstName: "",
    statuses: [""],
    accounts: [],
    viewed: [],
  },
  selected: {
    sessionSource: SourceType.Unknown,
    sessionId: "",
    trackingNumber: "",
    expiresOnUtc: "",
    expiresIn: 0,
    state: SessionState.NOT_VERIFIED,
    lastUpdatedAtUtc: "",
    caspioIdNameValue: "",
    sharedBy: "",
  },
  sessionNotification: {
    type: "",
    message: "",
    icon: "",
    randomId: 0,
  },
};
const sessionsReducer = (
  state = initialState,
  { type, payload }: SessionsAction
) => {
  switch (type) {
    case SessionDataType.CLEAR_SELECTED_SESSION:
      return {
        ...state,
        selected: initialState.selected,
      };
    case SessionDataType.SET_SESSION_BY_ID:
      return {
        ...state,
        selected: payload,
      };

    case SessionDataType.GET_SESSION_BY_ID:
      return {
        ...state,
        currentAccounts: initialState.currentAccounts,
        selected: initialState.selected,
      };

    case SessionDataType.SET_SESSIONS:
      return {
        ...state,
        list: payload,
      };
    case SessionDataType.SET_SESSION_NOTIFICATION:
      return {
        ...state,
        sessionNotification: {
          type: payload.type,
          message: payload.message,
          icon: payload.icon,
          randomId: payload.randomId,
        },
      };
    case SessionDataType.CLEAR_SESSION_NOTIFICATION:
      return {
        ...state,
        sessionNotification: {
          type: "",
          message: "",
          icon: "",
          randomId: 0,
        },
      };
    case SessionDataType.SET_ACCOUNTS:
      return {
        ...state,
        currentAccounts: payload,
      };
    case SessionDataType.GET_ACCOUNTS:
      return {
        ...state,
        currentAccounts: initialState.currentAccounts,
      };
    case SessionDataType.SET_ACCOUNT_VIEWED:
      const updatedViewed = state.currentAccounts.viewed.map(
        (accountStatus) => {
          if (accountStatus[payload] !== undefined)
            accountStatus[payload] = true;
          return accountStatus;
        }
      );
      const updatedCurrentAccounts = {
        ...state.currentAccounts,
        viewed: updatedViewed,
      };
      return {
        ...state,
        currentAccounts: updatedCurrentAccounts,
      };
    default:
      return state;
  }
};
export default sessionsReducer;
